import Layout from '@autoinformer/layouts/worksheet';

export const autoinformer_worksheet_route = {
  path: 'autoinformer/worksheets',
  component: Layout,
  children: [
    {
      path: ':id([\\d]*)',
      // path: '',
      name: 'autoinformer.worksheet.edit',
      component: () =>
        import(/* webpackChunkName: 'pbx-worksheet' */ '@autoinformer/pages/worksheets/form'),
      meta: {
        loadable: true
      }
    }
  ]
};
